<template>
    <div class="tpl-content-wrapper">
        <div class="tpl-portlet-components">
            <ul class="nav_title_ul">
                <li class="nav_title_li"
                    :class="nav_title==='课程' ? 'active_nav' : ''"
                    @click="tab_nav('课程')"
                >
                    推荐
                </li>
                <li class="nav_title_li"
                    :class="nav_title==='路径' ? 'active_nav' : ''"
                    @click="tab_nav('路径')"
                >
                    热点
                </li>
                <li class="nav_title_li"
                    :class="nav_title==='路径' ? 'active_nav' : ''"
                    @click="tab_nav('路径')"
                >
                    热评
                </li>
            </ul>

        </div>

        <div class="tpl-portlet-components">
            <div class="tpl-portlet-title">
                <div class="tpl-caption font-blue">
                    <i class="am-icon-dashboard"></i>
                    <span>时间归档</span>
                    <span class="desc"></span>
                </div>
            </div>
        </div>

        <div class="tpl-portlet-components" v-if="view_id === 'mylog'">
            <div class="tpl-portlet-title">
                <div class="tpl-caption font-blue">
                    <i class="am-icon-dashboard"></i>
                    <span>年龄段</span>
                    <el-dialog title="设置栏目" :visible.sync="dialogFormVisible">
                        <el-form :model="form">
                            <el-form-item label="栏目名称" :label-width="formLabelWidth">
                                <el-input v-model="form.name" autocomplete="off"></el-input>
                            </el-form-item>
                            <el-form-item label="是否禁用" :label-width="formLabelWidth">
                                <el-switch v-model="form.invisible"></el-switch>
                            </el-form-item>
                        </el-form>
                        <div slot="footer" class="dialog-footer">
                            <el-button @click="dialogFormVisible = false">取 消</el-button>
                            <el-button type="primary" @click="confirm_set_column">确 定</el-button>
                        </div>
                    </el-dialog>
                    <span class="desc">
                        <ul v-if="view_id === 'mylog'">
                            <li v-for="column in weblogs_post_column" :key="column['id']"
                                style="line-height: 20px">
                                <el-link @click="set_column(column)" class="el-icon-s-tools"></el-link>
                                <el-link v-if="!column.invisible" @click="set_display_posts_params(column.id)">
                                    {{column.display_name}}({{column.post_count}})
                                </el-link>
                                <el-link v-else disabled @click="set_display_posts_params(column.id)">
                                    {{column.display_name}}({{column.post_count}})
                                </el-link>

                            </li>
                        </ul>
                    </span>
                </div>
            </div>
        </div>

        <div class="tpl-portlet-components" v-if="view_id === 'moments'">
            <div class="tpl-portlet-title">
                <div class="tpl-caption font-blue">
                    <i class="am-icon-dashboard"></i>
                    <span>主题分类</span>
                    <span class="desc">
                        <ul v-if="view_id === 'moments'">
                            <li v-for="column in moments_post_column" :key="column['id']"
                                style="line-height: 20px">
                                <el-link @click="set_column(column)" class="el-icon-s-tools"></el-link>
                                <el-link v-if="!column.invisible" @click="set_display_posts_params(column.id)">
                                    {{column.display_name}}({{column.post_count}})
                                </el-link>
                                <el-link v-else disabled @click="set_display_posts_params(column.id)">
                                    {{column.display_name}}({{column.post_count}})
                                </el-link>
                            </li>
                        </ul>
                    </span>
                </div>
            </div>
        </div>
        <div class="tpl-portlet-components" v-if="view_id === 'management'">
            <div class="tpl-portlet-title">
                <div class="tpl-caption font-blue">
                    <i class="am-icon-dashboard"></i>
                    <span>主题分类</span>
                    <span class="desc">
                        <ul v-if="view_id === 'management'">
                            <li v-for="column in management_post_column" :key="column['id']"
                                style="line-height: 20px">
                                <el-link @click="set_column(column)" class="el-icon-s-tools"></el-link>
                                <el-link v-if="!column.invisible" @click="set_display_posts_params(column.id)">
                                    {{column.display_name}}({{column.post_count}})
                                </el-link>
                                <el-link v-else disabled @click="set_display_posts_params(column.id)">
                                    {{column.display_name}}({{column.post_count}})
                                </el-link>
                            </li>
                        </ul>
                    </span>
                </div>
            </div>
        </div>

        <div class="tpl-portlet-components">
            <div class="tpl-portlet-title">
                <div class="tpl-caption font-blue">
                    <i class="am-icon-dashboard"></i>
                    <span>最新留言</span>
                    <span class="desc"></span>
                </div>
            </div>
        </div>

    </div>

</template>

<script>
    import postApi from '@/api/post/post.js'
    import {mapState, mapActions, mapGetters} from 'vuex'

    export default {
        name: "learning_side",
        data() {
            return {
                dialogFormVisible: false,
                nav_title: '',
                form: {
                    name: '',
                    invisible: false,
                },
                setting_column_id: 0,
                formLabelWidth: '120px'
            }
        },
        computed: {
            ...mapState({
                view_id: state => state.main.view_id
            }),
            ...mapGetters({
                weblogs_post_column: 'post/weblogs_post_column',
                moments_post_column: 'post/moments_post_column',
                management_post_column: 'post/management_post_column',
            })
        },
        methods: {
            ...mapActions({
                get_post_column: 'post/get_post_column',
                change_active_column_id: 'post/change_active_column_id',
                change_display_posts_params: 'post/change_display_posts_params',
                change_column_setting: 'post/change_column_setting',
                change_warning_message: 'warningBar/change_message',
                change_warning_bar_style_class: 'warningBar/change_warning_bar_style_class'
            }),
            set_display_posts_params: function (column_id) {
                this.change_display_posts_params({
                    'column_id': column_id,
                    'type': ''
                })
                this.change_active_column_id(column_id)
            },
            set_column(column) {
                this.dialogFormVisible = true;
                this.setting_column_id = column.id;
                this.form.name = column.display_name;
                this.form.invisible = column.invisible;
            },
            async confirm_set_column() {
                let args = {
                    'setting_column_id': this.setting_column_id,
                    'setting_column_name': this.form.name,
                    'setting_column_invisible': this.form.invisible,
                }
                let res = await postApi.set_column(args);
                let data = JSON.parse(res.data.result);

                this.change_warning_message(data.message);
                if (data.code === 'success') {
                    this.change_warning_bar_style_class('success');
                    this.change_column_setting(data.column_setting);
                    this.dialogFormVisible = false;
                } else {
                    this.change_warning_bar_style_class('alert');
                }
            }
        },
        mounted() {
            this.get_post_column()
        }
    }
</script>

<style scoped>

</style>